import { useMemo } from 'react'

const useTimezone = () => {
  const timezone = useMemo(() => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }, [])

  return timezone
}

export default useTimezone
